var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SubAPI } from "./SubAPI";
var FormConfigAPI = /** @class */ (function (_super) {
    __extends(FormConfigAPI, _super);
    function FormConfigAPI() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormConfigAPI.prototype.list = function (input) { return this.fetcher.get("/api/form/configs", input); };
    FormConfigAPI.prototype.get = function (input) { return this.fetcher.get("/api/form/config", input); };
    FormConfigAPI.prototype.bulkArchive = function (input) { return this.fetcher.post("/api/form/config/bulk-archive", input); };
    FormConfigAPI.prototype.upsert = function (input) { return this.fetcher.post("/api/form/config", input); };
    FormConfigAPI.prototype.publish = function (input) { return this.fetcher.post("/api/form/config/publish", input); };
    FormConfigAPI.prototype.listNotificationGroups = function (input) {
        return this.fetcher.get("/api/form/notification/groups", input);
    };
    FormConfigAPI.prototype.upsertNotificationGroup = function (input) { return this.fetcher.post("/api/form/notification/group", input); };
    FormConfigAPI.prototype.removeNotificationGroups = function (input) { return this.fetcher.post("/api/form/notification/groups/bulk-remove", input); };
    FormConfigAPI.prototype.listApprovals = function (input) {
        return this.fetcher.get("/api/form/approvals", input);
    };
    FormConfigAPI.prototype.upsertApproval = function (input) { return this.fetcher.post("/api/form/approval", input); };
    FormConfigAPI.prototype.removeApprovals = function (input) { return this.fetcher.post("/api/form/approvals/bulk-remove", input); };
    return FormConfigAPI;
}(SubAPI));
export { FormConfigAPI };
